import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { LocationKitchen } from "../../nonAdminUser/reports/home/weekMenuTypes"

type ServiceCenterState = {
    selectedKitchen: LocationKitchen | null
}

const initialState: ServiceCenterState = {
    selectedKitchen: null,
}

const serviceCenterSlice = createSlice({
    name: "serviceCenter",
    initialState,
    reducers: {
        setSelectedKitchen: (state, action: PayloadAction<LocationKitchen>) => {
            state.selectedKitchen = action.payload
        },
    },
})

export const { setSelectedKitchen } = serviceCenterSlice.actions
export const serviceCenterReducer = serviceCenterSlice.reducer
